import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

// SVG Icon Components
const AIAvatarIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M512 779.195739c-57.599685-71.999606-91.199501-135.999256-102.39944-190.398959-51.19972-201.598898 257.598591-201.598898 206.398871 0-12.79993 55.999694-47.999738 119.999344-103.999431 190.398959z m315.198276 167.999081c-95.999475 41.599773-191.99895-25.59986-271.998512-115.19937 236.798705-297.598373 105.599423-457.597498-43.199764-457.597497-124.799318 0-195.198933 105.599423-167.999081 230.39874 15.999913 67.199633 57.599685 142.399221 124.799317 227.198757-73.599598 81.599554-137.599248 119.999344-195.198932 124.799318C160.001925 974.394671 70.402415 863.995275 112.002187 748.795905c35.199808-89.59951 255.9986-527.997113 265.598548-551.996981C412.800542 127.9993 435.20042 65.599641 512 65.599641c73.599598 0 99.199458 59.199676 137.599248 137.599248C732.798793 363.198014 854.398128 607.996675 911.997813 748.795905c30.399834 75.199589-3.199983 163.199108-84.799537 198.398915z m108.799405-311.998294C639.9993 9.599948 623.999388 0 512 0c-103.999431 0-148.799186 71.999606-193.598941 166.39909C75.202389 651.196439 52.802511 719.996063 49.602529 726.396028-7.997156 884.795161 112.002187 1023.9944 254.401409 1023.9944c49.599729 0 139.199239-14.399921 257.598591-142.399221 134.399265 145.599204 231.998731 142.399221 257.598591 142.399221 143.999213 0 262.398565-139.199239 204.79888-297.598372 0-9.599948-38.39979-89.59951-38.39979-91.199502z" fill="currentColor" />
  </svg>
);

const AdCopyIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M800 812.8h-576c-19.2 0-32-12.8-32-32s12.8-32 32-32h576c19.2 0 32 12.8 32 32s-12.8 32-32 32z" fill="currentColor" />
    <path d="M832 128c38.4 0 64 25.6 64 64v640c0 38.4-25.6 64-64 64H192c-38.4 0-64-25.6-64-64V192c0-38.4 25.6-64 64-64h640m0-64H192c-70.4 0-128 57.6-128 128v640c0 70.4 57.6 128 128 128h640c70.4 0 128-57.6 128-128V192c0-70.4-57.6-128-128-128z" fill="currentColor" />
    <path d="M499.2 588.8c0 12.8-6.4 19.2-19.2 19.2h-19.2c-12.8 0-19.2-6.4-19.2-19.2l-32-70.4H268.8l-25.6 70.4c-6.4 12.8-12.8 19.2-25.6 19.2h-12.8c-12.8 0-19.2-6.4-19.2-19.2 0-6.4 0-12.8 6.4-19.2l108.8-275.2c6.4-19.2 19.2-25.6 38.4-25.6h6.4c19.2 0 32 12.8 38.4 25.6l108.8 275.2c0 6.4 6.4 19.2 6.4 19.2zM396.8 467.2L339.2 320l-51.2 147.2h108.8zM576 608c-32 0-44.8-12.8-44.8-44.8V313.6c0-32 12.8-44.8 44.8-44.8h70.4c108.8 0 172.8 57.6 172.8 172.8 0 108.8-64 172.8-172.8 172.8H576z m185.6-172.8c0-76.8-38.4-121.6-115.2-121.6h-57.6v243.2h57.6c83.2 6.4 115.2-38.4 115.2-121.6z" fill="currentColor" />
  </svg>
);

const EmailIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M848 176H176c-61.86 0-112 50.15-112 112v186.67C64 495.28 80.71 512 101.33 512h149.33c20.62 0 37.33 16.72 37.33 37.33s-16.71 37.33-37.33 37.33H101.33C80.71 586.67 64 603.38 64 624c0 20.62 16.71 37.33 37.33 37.33H176c20.62 0 37.33 16.72 37.33 37.33S196.62 736 176 736h-64.59c-20.62-0.15-37.45 16.45-37.59 37.07a37.395 37.395 0 0 0 3.99 17.06C97.55 825.88 135.17 848.05 176 848h672c61.86 0 112-50.15 112-112V288c0-61.85-50.14-112-112-112z m23.89 144.85L583.68 560.53c-41.53 34.59-101.83 34.59-143.36 0L152.11 320.85c-15.88-13.2-18.05-36.77-4.85-52.64 13.2-15.88 36.76-18.06 52.64-4.86l288.21 239.68c13.84 11.53 33.94 11.53 47.79 0l288.21-239.68c15.88-13.2 39.45-11.02 52.64 4.86 13.19 15.87 11.02 39.44-4.86 52.64z" fill="currentColor" />
  </svg>
);

const BlogIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M97.152 960C78.848 960 64 946.112 64 929.024V156.928C64 105.6 108.48 64 163.392 64h615.424c54.912 0 99.392 41.6 99.392 92.928v362.24c0 17.088-14.848 30.976-33.152 30.976-18.304 0-33.088-13.888-33.088-31.04V156.928a30.016 30.016 0 0 0-9.728-21.888 34.368 34.368 0 0 0-23.424-9.088H163.392a34.368 34.368 0 0 0-23.424 9.088 30.016 30.016 0 0 0-9.664 21.888v772.032a30.016 30.016 0 0 1-9.728 21.952 34.368 34.368 0 0 1-23.424 9.088z m831.744-28.352h-107.52c-52.992-0.128-96-40.32-96-89.92v-65.024c0-49.6 43.008-89.792 96-89.856h107.52c16.512 0 29.824 12.48 29.824 27.84 0 15.424-13.312 27.904-29.824 27.904h-107.52c-20.096 0-36.352 15.296-36.416 34.112v64.576c0 18.816 16.32 34.048 36.48 34.048h78.912v-29.376h-40.32a30.656 30.656 0 0 1-28.224-13.12 26.496 26.496 0 0 1 0-29.504 30.656 30.656 0 0 1 28.224-13.12h66.304a26.24 26.24 0 0 1 5.248 0.384h0.64a36.48 36.48 0 0 1 15.552 6.976c7.68 5.888 12.16 14.72 12.224 24v77.056c0 3.456-0.64 6.912-1.856 10.24a29.44 29.44 0 0 1-29.248 22.784z" fill="currentColor" />
  </svg>
);

const ProductIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M950.857143 877.714286v73.142857h-219.428572v-73.142857h219.428572z m-268.190476 0v73.142857h-73.142857v-73.142857h73.142857zM544.402286 110.689524l295.253333 131.145143a73.142857 73.142857 0 0 1 43.471238 66.852571V585.142857h-73.142857v-207.603809L562.785524 487.375238v393.020952h-0.097524v24.746667l-18.285714 8.118857a73.142857 73.142857 0 0 1-59.367619 0L189.732571 782.165333A73.142857 73.142857 0 0 1 146.285714 715.312762V308.687238a73.142857 73.142857 0 0 1 43.446857-66.852571l295.302096-131.120762a73.142857 73.142857 0 0 1 59.367619 0zM219.428571 374.125714v341.211429l270.214096 120.003047V485.888L219.428571 374.101333z" fill="currentColor" />
  </svg>
);

const PosterIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M899.859692 0h-762.617436C90.505846 0 52.512821 37.481026 52.512821 83.547897v856.904206C52.512821 986.518974 90.518974 1024 137.242256 1024h762.617436C946.609231 1024 984.615385 986.532103 984.615385 940.452103V83.547897C984.615385 37.481026 946.596103 0 899.859692 0z" fill="currentColor" />
  </svg>
);

const MarketSurveyIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M928 254.4c-18.4-20-44-31.2-71.2-31.2H167.2c-27.2 0-52.8 11.2-71.2 31.2-18.4 20-27.2 46.4-24.8 72.8l32 371.2c4.8 56 51.2 99.2 107.2 99.2H224v144c0 17.6 14.4 32 32 32h512c17.6 0 32-14.4 32-32v-144h13.6c56 0 102.4-43.2 107.2-99.2l32-371.2c2.4-26.4-6.4-52.8-24.8-72.8z" fill="currentColor" />
    <path d="M384 387.2c-17.6 0-32 14.4-32 32v192c0 17.6 14.4 32 32 32s32-14.4 32-32v-192c0-17.6-14.4-32-32-32zM512 467.2c-17.6 0-32 14.4-32 32v112c0 17.6 14.4 32 32 32s32-14.4 32-32v-112c0-17.6-14.4-32-32-32zM640 339.2c-17.6 0-32 14.4-32 32v240c0 17.6 14.4 32 32 32s32-14.4 32-32v-240c0-17.6-14.4-32-32-32z" fill="currentColor" />
  </svg>
);

const ImageGenerationIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792z m0-129.8L732.1 443.9c-3.2-3.7-7.9-5.9-12.9-5.9s-9.7 2.1-12.9 5.9L470.4 684.3l-122.7-145.5c-3.2-3.8-8-6-13-6-5.1 0-9.9 2.3-13 6L136 695.3V232h752v430.2z" fill="currentColor" />
    <path d="M304 456c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88z m0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z" fill="currentColor" />
  </svg>
);

const ImageCompositionIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 632H136V232h752v560z" fill="currentColor" />
    <path d="M424 440a56 56 0 1 0 112 0 56 56 0 1 0-112 0z m-184 256l128-128 98 98 184-184 158 158V760H240z" fill="currentColor" />
  </svg>
);

const SpeechSynthesisIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M762.24 480.64c-17.28 0-31.36 14.08-31.36 31.36v28.8c0 52.266667-20.906667 103.68-58.026667 140.586667a199.253333 199.253333 0 0 1-139.946666 58.026666h-58.666667c-52.266667 0-103.253333-21.12-140.16-58.026666a198.933333 198.933333 0 0 1-58.026667-140.586667V512c0-17.28-14.08-31.36-31.36-31.36-17.28 0-31.36 14.08-31.36 31.36v28.8c0.426667 142.933333 116.266667 259.84 258.773334 261.546667v52.266666h-54.826667c-17.28 0-31.36 14.08-31.36 31.36 0 17.28 14.08 31.36 31.36 31.36h172.586667c17.28 0 31.36-14.08 31.36-31.36 0-17.28-14.08-31.36-31.36-31.36h-54.826667v-52.266666c142.72-1.706667 258.56-118.4 258.773333-261.546667V512c0-17.28-14.08-31.36-31.36-31.36h-0.213333z" fill="currentColor" />
    <path d="M503.466667 687.146667c96.64 0 175.146667-78.72 175.146666-175.146667V281.813333C678.613333 185.386667 600.106667 106.666667 503.466667 106.666667c-96.64 0-175.36 78.72-175.36 175.146666V512c0 96.64 78.72 175.146667 175.146666 175.146667h0.213334z m-112.426667-405.333334c0-61.866667 50.346667-112.426667 112.426667-112.426666a112.426667 112.426667 0 0 1 112.426666 112.426666V512a112.426667 112.426667 0 0 1-224.853333 0V281.813333z" fill="currentColor" />
  </svg>
);

const Dashboard = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const navigate = useNavigate();

  // Quick access features with all available tools
  const quickAccess = [
    {
      id: 'ai-avatar',
      name: 'AI Avatar',
      description: 'Interactive AI conversations',
      icon: <AIAvatarIcon />,
      gradient: 'from-purple-500 via-pink-500 to-rose-500',
      path: '/ai-avatar',
    },
    {
      id: 'ad-copy',
      name: 'Ad Copy',
      description: 'Create compelling ads',
      icon: <AdCopyIcon />,
      gradient: 'from-blue-500 via-indigo-500 to-purple-500',
      path: '/ad-copy',
    },
    {
      id: 'email',
      name: 'Email Marketing',
      description: 'Professional email campaigns',
      icon: <EmailIcon />,
      gradient: 'from-cyan-500 via-blue-500 to-indigo-500',
      path: '/email-marketing',
    },
    {
      id: 'blog',
      name: 'Blog Posts',
      description: 'Engaging blog articles',
      icon: <BlogIcon />,
      gradient: 'from-green-500 via-emerald-500 to-teal-500',
      path: '/blog-posts',
    },
    {
      id: 'product',
      name: 'Product Descriptions',
      description: 'Persuasive product copy',
      icon: <ProductIcon />,
      gradient: 'from-orange-500 via-amber-500 to-yellow-500',
      path: '/product-descriptions',
    },
    {
      id: 'poster',
      name: 'Poster Design',
      description: 'Eye-catching posters',
      icon: <PosterIcon />,
      gradient: 'from-rose-500 via-red-500 to-pink-500',
      path: '/poster',
    },
    {
      id: 'market-survey',
      name: 'Market Survey',
      description: 'Market research insights',
      icon: <MarketSurveyIcon />,
      gradient: 'from-violet-500 via-purple-500 to-fuchsia-500',
      path: '/market-survey',
    },
    {
      id: 'image-generation',
      name: 'AI Image',
      description: 'Generate AI images',
      icon: <ImageGenerationIcon />,
      gradient: 'from-teal-500 via-cyan-500 to-sky-500',
      path: '/image-generation',
    },
    {
      id: 'image-composition',
      name: 'Image Composition',
      description: 'Compose and edit images',
      icon: <ImageCompositionIcon />,
      gradient: 'from-lime-500 via-green-500 to-emerald-500',
      path: '/image-composition',
    },
    {
      id: 'speech-synthesis',
      name: 'Speech Synthesis',
      description: 'Text to speech conversion',
      icon: <SpeechSynthesisIcon />,
      gradient: 'from-sky-500 via-blue-500 to-cyan-500',
      path: '/speech-synthesis',
    },
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar activeCategory={activeCategory} onCategoryChange={setActiveCategory} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header />

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto">
          <div className="max-w-7xl mx-auto px-6 py-8">
            {/* Hero Section */}
            <div className="mb-12 relative overflow-hidden bg-gradient-to-br from-primary-600 via-purple-600 to-pink-600 rounded-3xl p-10 text-white shadow-2xl">
              <div className="absolute inset-0 bg-black opacity-5"></div>
              <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full -mr-48 -mt-48"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -ml-32 -mb-32"></div>

              <div className="relative z-10 max-w-3xl">
                <div className="inline-block px-4 py-1.5 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium mb-4">
                  ✨ Welcome to Zest AI
                </div>
                <h1 className="text-5xl font-bold mb-4 leading-tight">
                  Create Amazing Content
                  <br />
                  <span className="text-primary-100">with AI Power</span>
                </h1>
                <p className="text-xl mb-8 text-primary-50 leading-relaxed">
                  Transform your ideas into professional content in seconds. Powered by cutting-edge AI technology.
                </p>
                <div className="flex gap-4">
                  <button
                    onClick={() => navigate('/ai-avatar')}
                    className="px-8 py-4 bg-white text-primary-600 font-semibold rounded-xl hover:bg-primary-50 transition-all transform hover:scale-105 shadow-lg"
                  >
                    Get Started
                  </button>
                  <button
                    onClick={() => navigate('/workspace')}
                    className="px-8 py-4 border-2 border-white text-white font-semibold rounded-xl hover:bg-white/10 transition-all backdrop-blur-sm"
                  >
                    View Workspace
                  </button>
                </div>
              </div>
            </div>

            {/* Quick Access */}
            <div className="mb-12">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-3xl font-bold text-gray-900">Quick Access</h2>
                  <p className="text-gray-500 mt-1">Jump into your favorite tools</p>
                </div>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
                {quickAccess.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => navigate(item.path)}
                    className="group relative bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-xl hover:border-transparent transition-all duration-300 text-left overflow-hidden"
                  >
                    {/* Gradient Background on Hover */}
                    <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>

                    {/* Icon */}
                    <div className={`relative w-14 h-14 bg-gradient-to-br ${item.gradient} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg`}>
                      <div className="text-white">
                        {item.icon}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="relative">
                      <h3 className="text-base font-semibold text-gray-900 mb-1 group-hover:text-primary-600 transition-colors">
                        {item.name}
                      </h3>
                      <p className="text-sm text-gray-500 leading-snug">
                        {item.description}
                      </p>
                    </div>

                    {/* Arrow Icon */}
                    <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity">
                      <svg className="w-5 h-5 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Features Section */}
            <div className="mb-12">
              <div className="text-center mb-10">
                <h2 className="text-3xl font-bold text-gray-900 mb-3">Why Choose Zest AI?</h2>
                <p className="text-gray-500 text-lg">Powerful features that make content creation effortless</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="group bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-transparent transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Lightning Fast</h3>
                  <p className="text-gray-600 leading-relaxed">Generate high-quality content in seconds with our advanced AI technology.</p>
                </div>

                <div className="group bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-transparent transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Professional Quality</h3>
                  <p className="text-gray-600 leading-relaxed">Get professional-grade content that resonates with your audience.</p>
                </div>

                <div className="group bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-xl hover:border-transparent transition-all duration-300">
                  <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg">
                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Fully Customizable</h3>
                  <p className="text-gray-600 leading-relaxed">Fine-tune every aspect to match your brand and style perfectly.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
